import Vue from 'vue'
import router from './router'
import store from './vuex'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import Vant from 'vant';
import 'vant/lib/index.css';

import Print from "@/plugs/print"

// import '@/common/css/font.css'

import {VueJsonp} from 'vue-jsonp'

Vue.config.productionTip = false

Vue.use(Vant);

Vue.use(ElementUI)

Vue.use(Print)

Vue.use(VueJsonp)

Vue.prototype.$EventBus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
